// export const serverUrl = "http://localhost:5500";
export const serverUrl = "https://hms-server-jm6c.onrender.com";
